import { Button, message } from 'antd';
import React, { useContext, useEffect, useMemo } from 'react';
import { AuditMarkingContext } from '../../../context';
import {
	auditMarkingTagging,
	auditMarkingNoPassGroup,
	getAuditMarkingGroupIns,
	auditMarkingEvaluate,
} from '../../../../../../api/inspiration'
import * as actiontypes from '../../../reducer/action';
import './WaterFallTitle.less';

function WaterFallTitle(props) {
	const { state, dispatch, queryData } = useContext(AuditMarkingContext);
	// current === 0 或者 1 时，即不通过图片阶段的下一步或者打标签的完成阶段
	const NoPassNextStep = async () => {
		const result = await getAuditMarkingGroupIns(
			state.groupData.id,
			true,
			true
		);
		if (result?.error?.code === 0) {
			const data = result?.data ?? [];
			let newInsGroup = [];
			for (let v of data) {
				if (newInsGroup.length >= 14) {
					break;
				}
				if (!v.tags && !v.delete && !v.newTags) {
					newInsGroup.push(v);
				}
			}
			if (newInsGroup.length === 0) {
				dispatch({
					type: actiontypes.setData,
					data: {
						current: 0,
						handleTagVisible: false,
						functionModalLoading: false,
						passAllButtonLoading: false,
						virtualWaterUpdate: false,
						insGroup: [],
						checkedAll: false,
						visible: false,
					},
				});
				queryData(state.page, 10);
				return message.success('该组打标完成！辛苦！');
			}
			dispatch({
				type: actiontypes.setData,
				data: {
					current: 1,
					handleTagVisible: true,
					functionModalLoading: false,
					passAllButtonLoading: false,
					virtualWaterUpdate: true,
					modalTitle: '图片打标',
					waterFallTitle: '步骤1/2：图片打标',
					insGroup: newInsGroup,
					checkedAll: false,
				},
			});
		} else {
			message.error('获取图片列表失败！');
		}
	};
	const starNextStep = async () => {
		const result = await getAuditMarkingGroupIns(
			state.groupData.id,
			true,
			true
		);
		if (result?.error?.code === 0) {
			const insGroup = result?.data ?? [];
			let array = [];
			array = insGroup.filter((v) => !v.star);
			console.log('array', array);
			if (array?.length === 0 && (state.current === 2 || state.current === 3)) {
				dispatch({
					type: actiontypes.setData,
					data: {
						current: 0,
						handleTagVisible: false,
						functionModalLoading: false,
						passAllButtonLoading: false,
						virtualWaterUpdate: false,
						insGroup: [],
						checkedAll: false,
						visible: false,
					},
				});
				queryData(state.page, 10);
				return message.success('该组评星完成！辛苦！');
			}
			dispatch({
				type: actiontypes.setData,
				data: {
					current: 3,
					functionModalLoading: false,
					passAllButtonLoading: false,
					virtualWaterUpdate: true,
					modalTitle: '图片评星',
					waterFallTitle: '评3星',
					insGroup: array,
					checkedAll: false,
				},
			});
		} else {
			message.error('获取图片列表失败！');
		}
	};
	const renderOtherButton = () => {
		if (state.current === 0) {
			return (
				<>
					<Button
						onClick={() => {
							let count = 0;
							state.insGroup.forEach((v) => {
								if (v.checked && !v.detete) {
									count++;
									v.delete = true;
									v.checked = !v.checked;
									v.visible = false;
								}
							});
							dispatch({
								type: actiontypes.setData,
								data: {
									insGroup: [...state.insGroup],
									modalRightCount: state.modalRightCount + count,
								},
							});
						}}
					>
						不通过
					</Button>
					<Button
						loading={state.passAllButtonLoading}
						onClick={async () => {
							const handledData = [];
							// console.log(dispatch);
							for (let v of state.insGroup) {
								if (v.delete) {
									handledData.push(v.id);
								}
							}
							if (handledData?.length === 0) {
								// 如果删除数量是0，跳过，直接进下一阶段
								dispatch({
									type: actiontypes.setTagInsGroup,
								});
								dispatch({
									type: actiontypes.setData,
									data: {
										current: 1,
										handleTagVisible: true,
										virtualWaterUpdate: true,
									},
								});
								return;
							}
							dispatch({
								type: actiontypes.setData,
								data: {
									functionModalLoading: true,
									passAllButtonLoading: true,
								},
							});
							message.info('正在与服务器进行通信，请稍等！');
							const result = await auditMarkingNoPassGroup(
								{ groupId: state.groupData.id, idList: handledData },
								state.username
							);
							if (result?.error?.code === 0) {
								NoPassNextStep();
							} else {
								message.error('发生错误了！请重试！');
							}
						}}
					>
						下一步
					</Button>
				</>
			);
		} else if (state.current === 1) {
			return (
				<>
					<Button
						loading={state.passAllButtonLoading}
						onClick={async () => {
							// 删除
							const deleteInsList = [];
							for (let v of state.insGroup) {
								if (v.delete) {
									deleteInsList.push(v.id);
								}
							}
							if (deleteInsList.length !== 0) {
								const deleteResult = await auditMarkingNoPassGroup({
									groupId: state.groupData.id,
									idList: deleteInsList,
								});
								if (deleteResult?.error?.code === 0) {
									message.success('该组打标签通过成功！');
								} else {
									dispatch({
										type: actiontypes.setData,
										data: {
											passAllButtonLoading: false,
											functionModalLoading: false,
										},
									});
									return message.error(
										'该组未通过图片失败，请联系管理员' +
										'  错误为：' +
										deleteResult?.error?.message,
										10
									);
								}
							}
							// console.log(deleteInsList, state.insGroup.length)
							if (deleteInsList.length === 1 && state.insGroup.length === 1) {
								// console.log(123145);
								return NoPassNextStep();
							}
							// 打标签
							const taggedInsList = [];
							for (let v of state.insGroup) {
								// 如果图片已经被打过标签，并且没有被删除
								if (v?.newTags && v.newTags?.length > 0 && !v.delete) {
									taggedInsList.push({
										id: v.id,
										tagList: v.newTags,
									});
								}
							}
							if (taggedInsList.length === 0) {
								return message.info('请打完标之后再提交！');
							}
							const finalTaggedData = {
								list: taggedInsList,
								groupId: state.groupData.id,
							};
							const username = localStorage.getItem('username');
							dispatch({
								type: actiontypes.setData,
								data: {
									passAllButtonLoading: true,
									functionModalLoading: true,
								},
							});
							const result = await auditMarkingTagging(
								finalTaggedData,
								username
							);
							if (result?.error?.code === 0) {
								message.success('该组打标签通过成功！');
							} else {
								dispatch({
									type: actiontypes.setData,
									data: {
										passAllButtonLoading: false,
										functionModalLoading: false,
									},
								});
								return message.error(
									'该组打标未通过，请联系管理员' +
									'  错误为：' +
									result?.error?.message,
									10
								);
							}
							NoPassNextStep();
						}}
					>
						完成
					</Button>
				</>
			);
		} else if (state.current === 2) {
			return (
				<>
					<Button
						onClick={() => {
							let count = 0;
							state.insGroup.forEach((v) => {
								if (v.checked && !v.star) {
									count++;
									v.star = 1;
									v.checked = false;
									v.visible = false;
								}
							});
							dispatch({
								type: actiontypes.setData,
								data: {
									insGroup: [...state.insGroup],
									modalRightCount: state.modalRightCount + count,
								},
							});
						}}
					>
						通过（⭐）
					</Button>
					<Button
						loading={state.passAllButtonLoading}
						onClick={async () => {
							const starTagList = [];
							for (let v of state.insGroup) {
								if (v.star) {
									starTagList.push(v.id);
								}
							}
							dispatch({
								type: actiontypes.setData,
								data: {
									passAllButtonLoading: true,
									functionModalLoading: true,
								},
							});
							if (starTagList.length === 0) {
								starNextStep();
								return;
							}
							const result = await auditMarkingEvaluate(
								{
									groupId: state.groupData.id,
									idList: starTagList,
									star: 1,
								},
								state.username
							);
							if (result?.error?.code === 0) {
								message.success('一星评价成功！');
							} else {
								dispatch({
									type: actiontypes.setData,
									data: {
										passAllButtonLoading: false,
										functionModalLoading: false,
									},
								});
								message.error(
									'评星接口出错，错误为' + result.error.message,
									10
								);
							}
							starNextStep();
						}}
					>
						下一步
					</Button>
				</>
			);
		} else if (state.current === 3) {
			return (
				<>
					<Button
						onClick={async () => {
							let count = 0;
							let newData = [];
							state.insGroup.forEach((v) => {
								if (v.checked && !v.star) {
									count++;
									v.star = 3;
									v.checked = false;
									v.visible = false;
									newData.push(v.id);
								}
							});
							if (newData.length === 0) {
								return message.error('请选择后在评星');
							}
							dispatch({
								type: actiontypes.setData,
								data: {
									passAllButtonLoading: true,
									functionModalLoading: true,
								},
							});
							let result = await auditMarkingEvaluate(
								{
									groupId: state.groupData.id,
									idList: newData,
									star: 3,
								},
								state.username
							);
							if (result?.error?.code === 0) {
								starNextStep();
								message.success('评星成功！');
							} else {
								message.error('评星失败，错误为：' + result?.error?.message);
							}
						}}
					>
						通过（⭐⭐⭐）
					</Button>
					<Button
						loading={state.passAllButtonLoading}
						onClick={async () => {
							const twoStarList = state.insGroup.map(v => v.id);
							dispatch({
								type: actiontypes.setData,
								data: {
									passAllButtonLoading: true,
									functionModalLoading: true,
								},
							});
							let result = null;
							message.info('批量接口较慢，请耐心等待！', 10);
							result = await auditMarkingEvaluate(
								{
									groupId: state.groupData.id,
									idList: twoStarList,
									star: 2,
								},
								state.username
							);
							if (result?.error?.code === 0) {
								message.success('评星级成功');
								dispatch({
									type: actiontypes.setData,
									data: {
										passAllButtonLoading: false,
										functionModalLoading: false,
										insGroup: [],
										visible: false,
									},
								});
								queryData(state.page, 10);
							} else {
								dispatch({
									type: actiontypes.setData,
									data: {
										passAllButtonLoading: false,
										functionModalLoading: false,
										checkedAll: false,
									},
								});
								message.error(
									'评星级发生错误，错误为' + result?.error?.message,
									10
								);
							}
						}}
					>
						剩余两星（⭐⭐）
					</Button>
				</>
			);
		}
	};
	return useMemo(
		() => (
			<div className='auditManagerWaterFallTop'>
				<div className='auditManagerWaterFallTopGap'></div>
				<h2>{state.waterFallTitle}</h2>
				<div className='auditManagerWaterFallTopButtonGroup'>
					<Button.Group>
						<Button
							type='primary'
							onClick={() => {
								const { insGroup, checkedAll } = state;
								insGroup.forEach((v) => {
									v.checked = !checkedAll;
									v.visible = false;
								});
								dispatch({
									type: actiontypes.setData,
									data: {
										insGroup: [...insGroup],
										checkedAll: !checkedAll,
									},
								});
							}}
						>
							{state.checkedAll ? '取消全选' : '全选当页'}
						</Button>
						{renderOtherButton()}
					</Button.Group>
				</div>
			</div>
		),
		[
			state.WaterFallTitle,
			state.current,
			state.checkedAll,
			state.insGroup,
			state.passAllButtonLoading,
			state.functionModalLoading,
			queryData,
		]
	);
}

export default WaterFallTitle;
